module.exports = __webpack_public_path__ + "img/cn_quotaIcon.b4391068.png";